import React from 'react';
import { motion } from 'framer-motion';
export const HowItWorks = () => {
  const steps = [{
    title: 'Auditoría',
    desc: 'Ajustas el entorno y las luces de tu casa según las guías.'
  }, {
    title: 'Sincronización',
    desc: 'Aplicas las ventanas de vigilia para que tu bebé esté en el punto óptimo de cansancio.'
  }, {
    title: 'Independencia',
    desc: 'Usas el protocolo de 14 días para que aprenda a encadenar ciclos de sueño solo, sintiéndose seguro.'
  }];
  return <section className="py-16 md:py-24 px-6 max-w-4xl mx-auto" data-id="element-38">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-40">
          ¿Cómo funciona?
        </h2>
      </motion.div>

      <div className="space-y-8 relative before:absolute before:inset-0 before:ml-6 md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-sand/50" data-id="element-41">
        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-42">
            <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-cream bg-terracotta text-white font-serif text-xl shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-sm z-10" data-id="element-43">
              {index + 1}
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-sm border border-sand/30" data-id="element-44">
              <h3 className="font-serif text-xl text-charcoal mb-2" data-id="element-45">
                {step.title}
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-46">{step.desc}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
};